/*
 * File: LoginDialogHandler.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles a valid login and passes login state to the child component
 */
import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { LoginContext } from "../state/LoginProvider";

const LoginDialogHandler = ({ children }) => {
  // provider state
  const { dialog, login, timer } = useContext(LoginContext);

  useEffect(() => {
    const init = () => {
      // valid login so hide the dialog and start the logout timer
      if (login.valid === true) {
        dialog.hide();
        timer.start();
      }
    };
    init();
    // watch for changes to the valid prop in login state
  }, [login.valid, dialog, timer]);

  // props to provide to the child component
  const childProps = {
    open: dialog.open,
    error: login.error,
    loggingIn: login.loggingIn,
    onSubmit: login.onSubmit,
    wasAutoLoggedOut: login.wasAutoLoggedOut
  };

  return React.cloneElement(children, childProps);
};

LoginDialogHandler.propTypes = {
  children: PropTypes.node
};

export default LoginDialogHandler;
